'use client';

import { SectionCard, SectionParagraph } from './section-card';
import { SectionGrid } from './section-grid';
import { VerticalStageFlow } from './stage-flow';
import type { DefinitionJourney } from '@/hooks/use-definition';

interface JourneyTemplateProps {
  journey: DefinitionJourney;
}

export function JourneyTemplate({ journey }: JourneyTemplateProps) {
  const stages = Array.isArray(journey.stages) ? journey.stages : [];
  const hasPainsOrOpportunities = journey.pains || journey.opportunities;

  return (
    <div className="space-y-6">
      {/* Overview */}
      {journey.description && (
        <SectionCard title="Journey Overview">
          <SectionParagraph text={journey.description} />
        </SectionCard>
      )}

      {/* Journey Stages Timeline */}
      {stages.length > 0 && (
        <SectionCard title="Journey Stages">
          <VerticalStageFlow
            stages={stages.map(s => ({
              name: s.name,
              steps: s.steps,
              touchpoints: s.touchpoints,
              emotion: typeof s.emotions === 'string' ? s.emotions : undefined,
            }))}
          />
        </SectionCard>
      )}

      {/* Pain Points & Opportunities */}
      {hasPainsOrOpportunities && (
        <SectionGrid>
          {journey.pains && (
            <SectionCard title="Pain Points" dotColor="bg-red-500" titleColor="text-red-600" borderColor="border-red-200">
              <SectionParagraph text={journey.pains} />
            </SectionCard>
          )}
          {journey.opportunities && (
            <SectionCard title="Opportunities" dotColor="bg-green-500" titleColor="text-green-600" borderColor="border-green-200">
              <SectionParagraph text={journey.opportunities} />
            </SectionCard>
          )}
        </SectionGrid>
      )}
    </div>
  );
}
